exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-with-inline-button button[data-v-64b38cb6]{position:absolute;right:0;top:25px;right:19px}", ""]);

// exports
